<div class="mat-dialog-title" mat-dialog-title="">
    <h2>Confirmation</h2>
    <button mat-button mat-dialog-close class="close">Cancel</button>
</div>
<div mat-dialog-content class="example-container pt-3">
    {{ data.message }}
</div>
<div mat-dialog-actions class="row">
    <div class="col-12">
        <div class="text-center py-3 d-flex  justify-content-center"> 
            <button mat-raised-button color="primary" (click)="onNo()" type="button" class="btn-outline-black me-3">No </button>
            <button mat-raised-button color="primary" type="button" (click)="onYes()" class=" btn-black ">Yes </button>&nbsp;&nbsp;                
        </div>
    </div>
</div>